<template>
  <div class="group" :style="{height:show ? 22+grouplist.length*44+'px' : 0,opacity:show ? 1 : 0}">
    <div class="group-angle bg-white"></div>
    <div class="group-list flex-vc bg-white">
      <div class="group-single flex-cm font-size14 black-font" v-for="(item,index) in grouplist" @click="setgroup(item.id)">{{item.name}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'group',
    props:{
      cid:String,
      show:{
        type:Boolean,
        value:false
      },
      id:String
    },
    data () {
      return {
        openid:JSON.parse(localStorage.getItem('userinfo')).openid,
        grouplist:[]
      }
    },
    methods:{
      selectdraft(id){
        console.log(id)
        this.$emit('selectdraft',id);
      },
      getgroup(){
        this.$http({
          url:'https://pfotoo.com?s=App.Contribution.GetGroupByContribution'+this.$getsign(),
          params:{
            cid:this.cid,
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
            console.log(json)
            this.grouplist=json.data;
          }
        })
      },
      setgroup(id){
        if(this.id!=''){
          this.$http({
            url:'https://pfotoo.com?s=App.Contribution.InsertGroup'+this.$getsign(),
            params:{
              wid:this.id,
              gid:id
            },
            method:'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res)=>{
            console.log(res.body)
            let json=res.body;
            if(res.body.ret==200){
              console.log(json)
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
            }
          })
        }else{
          this.$message({
              showClose: true,
              message: '请选择投稿'
          });
        }

      }
    },
    mounted(){
      this.getgroup();
    }
  }
</script>

<style>
  .group{
    width:120px;
    height:0;
    position: absolute;
    left:0px;
    right:0px;
    top:32px;
    margin: 0 auto;
    border-radius:3px;
    transition: height ease .3s;
    padding-top:27px;
    box-sizing: border-box;
    overflow:hidden;
    opacity: 0;
  }
  .group-angle{
      width: 10px;
      height: 10px;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      position: absolute;
      top: 22px;
      left: 0;
      right: 0;
      margin: 0 auto;
      border-right: 1px solid rgba(0,0,0,.1);
      border-top: 1px solid rgba(0,0,0,.1);
      z-index:3;
  }
  .group-list{
    width: 100%;
    position: relative;
    z-index:2;
    border: 1px solid rgba(0,0,0,.1);
    box-sizing: border-box;
  }
  .group-single{
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #EEF2F2;
    box-sizing: border-box;
  }
  .group-single:last-child{
    border-bottom: 0;
  }
  .group-single:hover{
    color: #3DC4A7;
  }
</style>



// WEBPACK FOOTER //
// src/components/group.vue